import React from 'react';
import { useMemoizedFn } from 'ahooks';
import { useConfigAtomValues, useStateAtomValues } from '../state';
export default function usePayChannelId() {
  var _useConfigAtomValues = useConfigAtomValues(),
    payChannelList = _useConfigAtomValues.payChannelList;
  var _useStateAtomValues = useStateAtomValues(),
    payMethod = _useStateAtomValues.payMethod;

  // 获取当前支付方式映射出来的channelId
  var getCurPayChannelId = useMemoizedFn(function () {
    if (payMethod) {
      var _payChannelList$find;
      return payChannelList === null || payChannelList === void 0 ? void 0 : (_payChannelList$find = payChannelList.find(function (item) {
        return item.payMethod === payMethod;
      })) === null || _payChannelList$find === void 0 ? void 0 : _payChannelList$find.channelId;
    }
    return undefined;
  });
  var channelId = React.useMemo(function () {
    return getCurPayChannelId();
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [payMethod, payChannelList]);
  return {
    getCurPayChannelId: getCurPayChannelId,
    channelId: channelId
  };
}